import { Injectable } from '@angular/core';
import { Conversation } from '@elevenlabs/client';
import { ElevenLabsVoiceService } from './elevenlabs-voice.service';

@Injectable({ providedIn: 'root' })
export class ElevenLabsAgentService {
    private conversation: any;
    private conversationId = '';

    constructor(private voice: ElevenLabsVoiceService) {}

    async start(
        partnerid: string,
        onMode: (mode: string) => void,
        onError: () => void,
        onMessage: (message: string, source: 'user' | 'ai', conversationId: string) => void,
        onToolResult: (toolName: string, result: unknown) => void,
    ): Promise<void> {
        try {
            await this.stop();
            const signedUrl = await this.voice.createAgentSignedUrl(partnerid);
            if (!signedUrl) throw new Error('Missing ElevenLabs agent signed URL');
            this.conversation = await Conversation.startSession({
                signedUrl,
                onConnect: ({ conversationId }) => { this.conversationId = conversationId; },
                onModeChange: ({ mode }) => onMode(mode),
                onError: () => onError(),
                onMessage: ({ message, source }) => onMessage(message, source, this.conversationId),
                onAgentToolResponse: (event: any) => {
                    // ElevenLabs SDK versions do not consistently use the same
                    // property for an MCP tool response. Do not lose offer cards
                    // merely because the result is wrapped outside full_tool_result.
                    const result = event?.full_tool_result
                        ?? event?.tool_result
                        ?? event?.result
                        ?? event?.response;
                    const toolName = event?.tool_name ?? event?.toolName ?? event?.name;
                    if (toolName && result !== undefined && result !== null) {
                        onToolResult(String(toolName), result);
                    }
                },
                onDisconnect: () => { this.conversation = undefined; this.conversationId = ''; },
            });
        } catch (error) {
            console.error('[ElevenLabs agent] Session start failed', error);
            throw error;
        }
    }

    async stop(): Promise<void> {
        if (this.conversation) await this.conversation.endSession();
        this.conversation = undefined;
        this.conversationId = '';
    }
}
